import { useQuery } from "@tanstack/react-query"

import { bffApi } from "@/queries/apiClient"
import type EditSkiPassViewModel from "@/queries/models/EditPass"
import queryKeys from "@/queries/queryKeys"

const useEditPassQuery = (cartItemId: string | null) => {
  return useQuery<EditSkiPassViewModel>({
    queryKey: queryKeys.editPass(cartItemId ?? ""),
    queryFn: async () => {
      const res = await bffApi.get<EditSkiPassViewModel>("/edit", {
        params: { cartItemId },
      })
      return res.data
    },
    enabled: !!cartItemId,
  })
}

export default useEditPassQuery
